import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { queryKey } from 'src/constants/QueryKey';
import { Card, FontAwesome, SubmitButton } from 'src/containers/Elements';
import { api } from 'src/helpers/API';
import { toastify } from 'src/helpers/Toastify';
import { useAxios } from 'src/hooks/useAxios';
import { Colors } from 'src/types/Color';

function SyncPlanFeature({ dirtyFields }: { dirtyFields?: any }) {
	const { t } = useTranslation();
	const { sendRequest, isLoading } = useAxios();
	const { subscriptionPlan_id } = useParams();
	const queryClient = useQueryClient();
	const resyncSubscription = async () => {
		await sendRequest(
			api.resyncPartnerSubscriptionPlan(subscriptionPlan_id as string),
			{ method: 'PUT' },
			() => {
				queryClient.invalidateQueries({
					queryKey: queryKey.subscriptionPlansFeature
				});
				queryClient.invalidateQueries({
					queryKey: queryKey.subscriptionPlans
				});
				toastify(t('toastify.subscription-resync-success'), {
					type: 'success'
				});
			}
		);
	};

	const isDirty =
		dirtyFields &&
		Object.keys(dirtyFields).some((key) =>
			[
				'publishedJobs',
				'publishedInternships',
				'maxTopJobs',
				'topJobExpiredAfterDays',
				'topJobEnabled'
			].includes(key)
		);
	return (
		<Card className="d-flex  align-items-center justify-content-between">
			<div className="d-flex  gap-2 flex-column">
				<span className="text-secondary">
					<FontAwesome
						icon="circle-info"
						size="lg"
						className="text-secondary me-2 "
					/>
					{t('text.resync-plan')}
				</span>
				<span className="text-secondary">
					<FontAwesome
						icon="circle-info"
						size="lg"
						className="text-secondary me-2"
					/>
					{t('text.resync-after-save')}
				</span>
			</div>

			<SubmitButton
				type="button"
				isSubmitting={isLoading}
				disabled={isDirty}
				label={t('button.resync-subscription')}
				icon={'refresh'}
				savingLabel={t('button.resyncing')}
				color={Colors['white-blue']}
				onClick={resyncSubscription}
			/>
		</Card>
	);
}

export default SyncPlanFeature;
